// Header: scroll effect + burger menu

const header = document.querySelector('.site-header');
const burger = document.querySelector('.site-header__burger');

// Фон при скролле
window.addEventListener('scroll', () => {
  header.classList.toggle('is-scrolled', window.scrollY > 20);
});

// Бургер
burger?.addEventListener('click', () => {
  const isOpen = header.classList.toggle('is-open');
  burger.setAttribute('aria-expanded', isOpen);
});
